import { NgModule, Optional, SkipSelf } from "@angular/core";
import { MATERIAL_SANITY_CHECKS } from "@angular/material/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { FuseConfirmationModule } from "./services/confirmation";
import { FuseMediaWatcherModule } from "./services/media-watcher/media-watcher.module";
import { FuseSplashScreenModule } from "./services/splash-screen/splash-screen.module";
import { FuseUtilsModule } from "./services/utils/utils.module";
import { FusePipesModule } from "./pipes/pipes.module";

@NgModule({
    imports: [FuseConfirmationModule, FuseMediaWatcherModule, FuseSplashScreenModule, FuseUtilsModule, FusePipesModule],
    providers: [
        {
            // Disable 'theme' sanity check
            provide: MATERIAL_SANITY_CHECKS,
            useValue: {
                doctype: true,
                theme: false,
                version: true,
            },
        },
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: "outline",
                floatLabel: "auto",
                subscriptSizing: "dynamic",
                hideRequiredMarker: false,
            },
        },
    ],
})
export class FuseModule {
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: FuseModule) {
        if (parentModule) {
            throw new Error("FuseModule has already been loaded. Import this module in the AppModule only!");
        }
    }
}
